import { render } from "./ContentBase.vue?vue&type=template&id=9b6730b8&scoped=true"
import script from "./ContentBase.vue?vue&type=script&lang=js"
export * from "./ContentBase.vue?vue&type=script&lang=js"

import "./ContentBase.vue?vue&type=style&index=0&id=9b6730b8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b6730b8"]])

export default __exports__